import DefaultScores from 'components/commandpanel/ExperimentPanel/DefaultScores/DefaultScores';
import MarcoScore from 'components/commandpanel/ExperimentPanel/MarcoScore/MarcoScore';
import RMTabs from 'components/customComponents/Controls/RMTabs';
import { ITabItem } from 'components/tab';
import React, { useMemo } from 'react';
import { useRMDispatch, useRMSelector } from 'redux/hooks';
import {
  useCurrentSelectedWellDropDetails,
  useScores,
  useSelectedWellDropDetails,
  useWellScoresForDrops,
} from 'redux/hooks/searchnFilter';
import {
  markDisputedScores,
  moveNextSearchResultItem,
} from 'redux/reducers/searchnFilterReducer';
import { useAllScoresGroups } from 'redux/hooks/common';
import { selectAutoSelectNextWell } from 'redux/selectors/StateSelectors';
import { batch } from 'react-redux';
import { DisputedScoresIds } from 'business/models/Models';
import { scoreWellsThunk } from 'redux/thunks/searchnFilter';
import { ScoresOfWellDrops } from 'components/Experiment/constants';
import HitsFilter from 'components/Experiment/FindDrop/ScoringFilters/HitsFilter';

const ScoresPanel = () => {
  const dispatch = useRMDispatch();
  const scoresByDrop = useScores().scores;
  const usedScoreGroupIds = useMemo(() => {
    const ids = new Set<number>();
    Object.values(scoresByDrop ?? {}).forEach((dropScores) => {
      dropScores?.forEach((score) => {
        if (score?.wellDropScoreGroupId != null) {
          ids.add(Number(score.wellDropScoreGroupId));
        }
      });
    });
    return ids;
  }, [scoresByDrop]);
  const selectedWellDetails = useSelectedWellDropDetails();
  const currentWellDropDetails = useCurrentSelectedWellDropDetails();
  const selectedWellScores = useWellScoresForDrops(selectedWellDetails);

  const scoresOptionsList = useAllScoresGroups();
  const autoSelectNextWell = useRMSelector(selectAutoSelectNextWell);
  if (!selectedWellDetails.length || !currentWellDropDetails) {
    return null;
  }

  const applyScoring = (wellDropScoreId: number, wellDropScoreGroupId: number) => {
    const isSingleWellSelected = selectedWellDetails.length === 1;
    if (autoSelectNextWell && isSingleWellSelected) {
      batch(() => {
        dispatch(moveNextSearchResultItem());
        dispatch(
          scoreWellsThunk({
            wellDropScoreId,
            wellDropScoreGroupId,
            selectedWellDetails,
            selectedWellScores,
          }),
        );
      });
    } else {
      dispatch(
        scoreWellsThunk({
          wellDropScoreId,
          wellDropScoreGroupId,
          selectedWellDetails,
          selectedWellScores,
        }),
      );
    }
  };

  const handleOnMarkDisputedScore = (disputedScoreGroupsIds: DisputedScoresIds[]) => {
    dispatch(
      markDisputedScores({
        dropId: currentWellDropDetails?.dropId,
        imageBatchId: currentWellDropDetails?.imageBatchId,
        disputedScoreGroupsIds,
      }),
    );
  };
  const tabItems: ITabItem[] = [
    {
      title: 'Filter',
      eventKey: 'filter',
      content: (
        <div
          id="searchandfilter-score-hits-filter"
          className="px-[10px] py-2 overflow-auto"
        >
          <HitsFilter usedScoreGroupIds={usedScoreGroupIds} />
        </div>
      ),
    },
    {
      title: 'Score Group',
      eventKey: 'scoreGroup',
      content: (
        <DefaultScores
          allScoresOptionsList={scoresOptionsList}
          selectedWellDetails={selectedWellDetails}
          selectedWellsScores={selectedWellScores as ScoresOfWellDrops[][]}
          applyScoring={applyScoring}
        />
      ),
    },
    {
      title: 'Auto Score',
      eventKey: 'autoScore',
      content: (
        <MarcoScore
          wellDetails={currentWellDropDetails}
          handleOnMarkDisputedScore={handleOnMarkDisputedScore}
          selectedWellsScores={selectedWellScores as ScoresOfWellDrops[][]}
        />
      ),
    },
  ];
  return (
    <div
      id="searchandfilter-score-panel-wrapper"
      className="container-fluid p-0 border h-full"
    >
      <div
        id="scorepanel-header"
        className="flex flex-row w-full min-h-[7vh] bg-[#F5F5F5] items-center pl-[1.5%]"
      >
        <div
          id="scorepanel-header-left-title"
          className="font-semibold text-ellipsis overflow-hidden my-auto"
          title={'Score'}
        >
          Score
        </div>
      </div>
      <div id="searchandfilter-score-panel-tab-wrapper" className="row h-full">
        <div id="searchandfilter-score-panel-tab-container" className="col-md-12 h-full">
          <RMTabs
            tabItems={tabItems}
            defaultActiveKey={'filter'}
            id={'searchandfilter-score-panel-tab-scoreTab'}
          />
        </div>
      </div>
    </div>
  );
};

export default ScoresPanel;
